import styled from "styled-components";

export const Container = styled.div`
  height: 94px;
  display: flex;
  align-items: center;
  position: relative;
`;

export const TextContainer = styled.div<{ isSkipped?: boolean }>`
  padding-right: ${({ theme }) => theme.spacings.xs5};
  flex-grow: 1;
  ${({ isSkipped }) => isSkipped && "text-decoration: line-through;"}
`;

export const ActionWrapper = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacings.xs3};
  padding: 0 ${({ theme }) => theme.spacings.xs};
  flex-shrink: 0;
`;
